<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttLabel="bsp_name" [ttModel]="page.bsp_name" ttReadonly></tt-input>
        <tt-input *ngIf="page.bspug_keyno === '0'" ttLabel="bspug_name" [(ttModel)]="page.bspug_name" ttRequired></tt-input>
        <tt-input-buttons *ngIf="page.bspug_keyno !== '0'" ttLabel="bspug_name" [ttModel]="page.bspug_name" [ttButtons]="bspUgNameButtons" [ttReadonly]="true"></tt-input-buttons>
        <tt-input ttLabel="reg_by_user" [ttModel]="page.reg_by_user" ttReadonly></tt-input>
        <tt-input ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttReadonly></tt-input>
        <tt-button-save ttText="bspug_save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
